import { useMemo } from 'react';
import { ICategory, TCategoriesTree, TCategoryArray } from '@features/categories';

const convertToChildArray = (categoryChild: ICategory): TCategoryArray => {
  const result: TCategoryArray = {
    ...categoryChild,
    children: [],
  };
  const newChildren: TCategoryArray[] = [];
  if (categoryChild.children) {
    Object.values(categoryChild.children).forEach((categoryChild2) => {
      const newChild: TCategoryArray = convertToChildArray(categoryChild2 as ICategory);
      newChildren.push(newChild);
    });
    newChildren.sort((a, b) => a.position - b.position);
    result.children = newChildren;
  }
  return result;
};

const convertToArray = (categoriesArray: TCategoriesTree): TCategoryArray[] => {
  const result: TCategoryArray[] = [];
  Object.values(categoriesArray).forEach((category) => {
    const newCategory: TCategoryArray = {
      ...(category as ICategory),
      children: [],
    };
    const categoryTyped = category as ICategory;
    if (categoryTyped.children) {
      Object.keys(categoryTyped.children).forEach((categoryChildKey) => {
        const newChild: TCategoryArray = convertToChildArray(categoryTyped.children[categoryChildKey] as ICategory);
        newCategory.children.push(newChild);
      });
      newCategory.children.sort((a, b) => a.position - b.position);
    }
    result.push(newCategory);
  });
  result.sort((a, b) => a.position - b.position);
  return result;
};

const useCategoryArray = (initialState: TCategoriesTree): ICategory[] =>
  useMemo(() => convertToArray(initialState), [initialState]) as unknown as ICategory[];

export default useCategoryArray;
